import { Link } from "react-router-dom";
import { categories, resources } from "@/mocks/resources";

const accents = [
  { bg: "bg-primary-50", border: "border-primary-200", icon: "text-primary-600", chip: "bg-primary-500 text-background-50" },
  { bg: "bg-accent-50", border: "border-accent-200", icon: "text-accent-600", chip: "bg-accent-500 text-background-50" },
  { bg: "bg-secondary-50", border: "border-secondary-200", icon: "text-secondary-600", chip: "bg-secondary-500 text-background-50" },
];

export default function CategoryQuickLinks() {
  return (
    <section aria-label="分类快捷入口" className="mt-6 md:mt-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
        {categories.map((category, index) => {
          const count = resources.filter((item) => item.category === category.key).length;
          const accent = accents[index % accents.length];
          return (
            <Link
              key={category.key}
              to={category.path}
              className={`group flex items-start gap-4 p-4 md:p-5 rounded-lg border ${accent.border} ${accent.bg} cursor-pointer hover:border-primary-300 transition-colors`}
            >
              <span className={`w-12 h-12 rounded-md flex items-center justify-center shrink-0 ${accent.chip}`}>
                <i className={`${category.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-2">
                  <span className="font-heading font-bold text-base text-foreground-950">{category.label}</span>
                  <span className="chip bg-background-50 text-foreground-500 border border-background-200">
                    {count} 部精选
                  </span>
                </span>
                <span className="block mt-1.5 text-xs text-foreground-600 leading-5 line-clamp-2">{category.intro}</span>
                <span className={`mt-3 flex items-center gap-1 text-xs font-medium ${accent.icon}`}>
                  进入{category.label}分类
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" aria-hidden="true"></i>
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}